import Vue from 'vue'

/**
 * Adds the given icon values to the framework icons object
 * @param {[key: string]: string} iconsToAdd An object that specifies the icon names and svg values (e.g. { iconName: 'svg' })
 */
export const injectIcons = framework => iconsToAdd => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    checkForDuplicateIcons(framework.icons.values, iconsToAdd)
  }
  framework.icons.values = {
    ...iconsToAdd,
    ...framework.icons.values
  }
}

function checkForDuplicateIcons (existingIcons, newIcons) {
  const existingIconKeys = Object.keys(existingIcons)

  Object.entries(newIcons).forEach(([key, path]) => {
    if (existingIcons[key] && existingIcons[key] !== path) {
      Vue.util.warn(`The icon '${key}' is being overwritten by an existing icon with the same name!`)
    } else {
      const existingIcon = existingIconKeys.find(iconKey => iconKey !== key && existingIcons[iconKey] === path)
      if (existingIcon) {
        Vue.util.warn(`The icon for '${key}' already exists, use '${existingIcon}' instead.`)
      }
    }
  })
}
